<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'AO_SELLER'"><a routerLink="/admin/sellerDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">Credits</li>
    </ol>
  </nav>

  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="row">
            <div class="col-6">
              <h5 class="control-label">Shipping Credits</h5><br><span
              style="font-size:46px">{{getCreditsAmount}}</span>
              <div>
                <a style="white-space: nowrap;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21.34 21.34">
                    <defs>
                      <style>.ab {
                            fill: #ee7125;
                          }

                      </style>
                    </defs>
                    <path class="ab"
                          d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z"
                          transform="translate(-3.375 -3.375)"/>
                  </svg>
                  <span class="ms-2" id="addProduct"><a routerLink="/admin/creditProcessing/{{user.accountOwnerId}}">Buy Credits
                    </a></span>
                </a>
              </div>
            </div>
            <div class="col-6">
              <label class="control-label">Transactions</label>
              <table class="table">
                <thead>
                <tr>
                  <th>Description</th>
                  <th>Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let o of getCreditsData">
                  <td><span [ngClass]="{'text-success' : o.amountStatus == 'Y','text-danger' : o.amountStatus == 'N'}">{{o.description}}</span></td>
                  <td><span [ngClass]="{'text-success' : o.amountStatus == 'Y','text-danger' : o.amountStatus == 'N'}">{{o.amount.toFixed(2)}}</span></td>
                </tr>
                </tbody>
              </table>

              <div>
                <strong>
                  <button class="btn btn-orange float-end" type="button" (click)="creditReports()">Credit Reports</button>
                </strong>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" *ngIf="invoiceRecords > 0">
      <div class="col">
        <div class="inner-box">
          <div class="row">
            <div class="col-12">
              <h5 class="control-label">Invoices</h5>
              <table class="table">
                <thead>
                <tr>
                  <th>Invoice#</th>
                  <th>Invoice Date</th>
                  <th>Reference Number</th>
                  <th>Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let o of invoiceData">
                  <td>{{o.invoiceNum}}</td>
                  <td>{{o.invoiceDate}}</td>
                  <td>{{o.refNumber}}</td>
                  <td>{{o.totalAmount}}</td>
                </tr>
                </tbody>
              </table>


            </div>

          </div>
        </div>

      </div>
    </div>
  </form>
</section>




